import { useTranslation } from "react-i18next";
import { LANGUAGES } from "@/i18n";
import { Languages } from "lucide-react";
import { useState } from "react";

export default function LanguageSwitcher({ variant = "header" }) {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = LANGUAGES.find((l) => l.code === i18n.resolvedLanguage) || LANGUAGES[0];

  const isDark = variant === "dark";
  const base = isDark ? "bg-transparent text-white border-white/40 hover:bg-white/10" : "bg-white text-[#0A0A0A] border-[#0A0A0A] hover:bg-[#F4F4F0]";

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`flex items-center gap-2 font-mono-mark text-[10px] px-3 py-2 border ${base}`}
        data-testid="language-switcher-btn"
      >
        <Languages className="w-3 h-3" />
        <span>{current.label}</span>
        <span className="text-xs leading-none">{current.flag}</span>
      </button>
      {open && (
        <div className={`absolute right-0 top-full mt-1 w-40 ${isDark ? "bg-[#0A0A0A] text-white border-white/40" : "bg-white border-[#0A0A0A]"} border brutal-shadow z-50`} data-testid="language-switcher-menu">
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              onClick={() => { i18n.changeLanguage(l.code); setOpen(false); }}
              className={`w-full flex items-center justify-between px-3 py-2 font-mono-data text-sm text-left ${l.code === current.code ? (isDark ? "bg-white/10" : "bg-[#FFD600]") : ""} hover:bg-[#F4F4F0] hover:text-[#0A0A0A]`}
              data-testid={`language-${l.code}`}
            >
              <span className="flex items-center gap-2"><span>{l.flag}</span>{l.name}</span>
              <span className="font-mono-mark text-[9px] opacity-60">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
